import PropTypes from "prop-types";
import { useCallback } from "react";
import { OFFER_TYPES } from "app/constants";
import { FormattedMessage } from "react-intl";
import { offerTypePropTypes } from "app/utils/propTypes";
import DurationLabel from "app/pages/.shared/DurationLabel";
import { Amount } from "app/components/ui/Amount/Amount";
import RadioFormik from "app/pages/.shared/form/RadioFormik";

const Duration = ({
	duration,
	minPrice,
	publicPrice,
	amountSuffix,
	productInfo = {},
	offerType,
	onChange = () => {},
	...props
}) => {
	const handleChange = useCallback(() => {
		onChange(duration);
	}, [duration]);

	return (
		<RadioFormik
			id={`duration-${duration}`}
			name="duration"
			value={String(duration)}
			toggle={handleChange}
			data-testid={props["data-testid"]}
		>
			<div className="duration__content">
				<div className="duration__label">
					<DurationLabel duration={duration} />
				</div>

				{minPrice && (
					<div className="duration__price">
						<Amount
							value={minPrice}
							prefix={<FormattedMessage id="offer.per.person.from.label" />}
							suffix={amountSuffix}
							size="xsmall"
							prefixSize="xxsmall"
							suffixSize="xxsmall"
							className="duration__amount"
						/>
					</div>
				)}

				{publicPrice && (
					<div className="duration__price duration__public-price">
						<Amount
							value={publicPrice}
							suffix={amountSuffix}
							size="xsmall"
							suffixSize="xxsmall"
							className="duration__amount duration__public-amount"
						/>
					</div>
				)}

				{productInfo.ul === true && offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION && (
					<div className="duration__info">
						<FormattedMessage id="search.engine.departure.city.info.business.flight" />
					</div>
				)}
			</div>
		</RadioFormik>
	);
};

Duration.propTypes = {
	offerType: offerTypePropTypes,
	productInfo: PropTypes.object,
	amountSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	duration: PropTypes.number,
	minPrice: PropTypes.number,
	publicPrice: PropTypes.number,
	field: PropTypes.object,
	"data-testid": PropTypes.string,
	onChange: PropTypes.func,
};

export default Duration;
